import styles from "./CurrentPolls.module.css";

const currentPollsStyle = {
    outerContainer: `flex flex-col gap-[8px] bg-themeColor rounded-[10px] px-[15px] py-[10px] w-full h-full
    `,
    heading: `text-[17px] font-Suisse font-[700] capitalize ${styles.heading}`,
    dividerContainer: `flex gap-2 w-[20%]`,
    divider: `bg-primaryHeading h-[2px]`,
    pollDataContainer: `flex flex-wrap gap-[22px] max-h-[535px] pr-2 overflow-y-auto ${styles.pollDataContainer}`,
    loaderContainer: `w-full h-full flex flex-col items-center justify-center`,
    noPollsContainer: `h-full flex flex-col items-center justify-center p-0 gap-[20px] ${styles.noPollsContainer}`,
    noPollsImage:  `w-full h-[auto] max-w-[200px] ${styles.noPollsImage}`,
    noPollsText: `text-white text-lg ${styles.noPollsText}`
};

const pollsStyle = {
    outerContainer: `relative my-[20px] w-[48%] z-[1] before:content-[''] before:absolute before:inset-0 before:bg-primaryGold before:rounded-[10px] before:rotate-[3deg] before:z-[-1] ${styles.outerContainer}`,
    outerContainerLive: `w-full`,
    polls: `flex flex-col gap-[6px] pt-[11px] pr-[17px] pb-[17px] pl-[15px] bg-liveGameColor p-4 rounded-[10px] w-full h-full relative ${styles.polls}`,
    pollsLive: `!bg-themeColor
                
    `,
    question: `text-[14px] ${styles.question}`,
    votesvalue: `text-right text-[12px] ${styles.votesvalue}`,
    polls_img: `w-[17px] h-[17px] max-w-full rounded-full
                screen-500:w-[20px] screen-500:h-[20px] 
    `,
    percent_img: `flex gap-[5px] items-center z-[1] text-[10px]
                  screen-500:text-[11px] screen-500:gap-[10px]
    `,
    checkbox: `bg-white rounded-full w-[20px] h-[20px] text-black flex items-center justify-center`,
    optionContainer: `flex items-center justify-between bg-liveGameBackground p-[10px] py-[3px] rounded-[8px] border-l border-primaryHeading`,
    options: `flex flex-col gap-2`,
    optionSelected: `bg-green-500`,
    optionText: `text-[12px] z-[1]
                 screen-500:text-[12px]
                 md:text-[14px]
    `,
    spinnerContainer:  `absolute inset-0 bg-black/50 flex items-center justify-center z-[2] rounded-lg`
};

export { currentPollsStyle, pollsStyle };
